import emptyLayoutState from "./emptyLayoutState"
import cxNavMenuVerticalState from "./cxNavMenuVerticalState"
import cxDialogState from "./cxDialogState"
import cxPageLayout from "./cxPageLayout"
import cxGraphicState from "./cxGraphicState"
import cxSystemTextState from "./cxSystemTextState"
import cxLoginState from "./cxLoginState"
import { materialLoader } from "core/materialLoader"
// 用来判断一些内部人员使用的组件展示
export const pageLayout = {
  cxPageLayout
}
export const layoutState = {
  emptyLayoutState
}
export const allState = {
  cxGraphicState,
  cxSystemTextState,
  ...materialLoader.getMenusByStageAndGroup("bigScreen", "element"),
  emptyLayoutState,
  cxNavMenuVerticalState
}

export const bigScreenState = {
  ...materialLoader.getMenusByStageAndGroup("bigScreen", "chart")
}
export const componentState = {
  ...materialLoader.getMenusByStageAndGroup("bigScreen", "component"),
  cxDialogState,
  cxLoginState
}
